export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-pencil-40f6dfb44daa3c803abac28420d833b1.svg";